import { theme } from "../../../App";
const styles = () => ({
  questionWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  vidoeAndImageContainer: {
    textAlign: "center",
    width: "100%",
    marginTop: 24,
  },
  field: {
    width: "99%",
  },

  helperText: {
    flexGrow: 50,
  },
  imageContentData: {
    backgroundColor: "#e6dede",
    minHeight: 200,
    minWidth: 90,
    [theme.breakpoints.up("sm")]: {
      minHeight: 360,
      minWidth: 160,
    },
    [theme.breakpoints.up("md")]: {
      minHeight: 560,
      minWidth: 250,
    },
  },
  videoContentData: {
    minHeight: 200,
    [theme.breakpoints.up("sm")]: {
      minHeight: 360,
    },
    [theme.breakpoints.up("md")]: {
      minHeight: 560,
    },
  },
});

export default styles;
